import { copyMarkdownAsPlainText } from "../../../utils/richClipboard";
import { downloadDocxClientSide, downloadPdfClientSide } from "./publicExport";

export const handleCopy = (markdown: string): Promise<void> =>
  copyMarkdownAsPlainText(markdown);

export const handleDownloadPdf = (
  markdown: string,
  rootEl: HTMLElement | null,
  filename = "jan-response"
): Promise<void> => downloadPdfClientSide(markdown, filename, rootEl);

export const handleDownloadDocx = (
  markdown: string,
  rootEl: HTMLElement | null,
  filename = "jan-response"
): Promise<void> => downloadDocxClientSide(markdown, filename, rootEl);
